import { useEffect, useMemo } from 'react';
import isNumber from 'lodash/isNumber';
import { useHistory } from 'react-router-dom';
import { CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON } from '@yme/common/constants';
import { useDispatch } from '@yme/hooks/useDispatch';
import { setFilterOptions } from '@yme/pdp-components/ProductCard';
import { useTransmission } from '@yme/pdp-components/ProductCard/components/ProductFilter/MotorcyclesFilter/useTransmission';
import { getFilterOptionByProductType } from '@yme/pdp-components/ProductCard/helpers';
import { STATUS_COLOR_CHANGE, STATUS_INIT, STATUS_RELOAD } from '../constants';
import { getColorIndex } from '../helpers';
import { prepareMotorcyclesFilterOptions } from './helpers';
export function useMotorcyclesFilter({ productFilterOptions, productVariantsByColor, colorVariants, }) {
    const { sku, colorItemIndex = 0 } = productFilterOptions;
    const dispatch = useDispatch();
    const history = useHistory();
    const isConfiguratorShowed = useMemo(() => {
        const queryParams = new URLSearchParams(history.location.search);
        return queryParams.get(CONFIGURATOR_PARAM_NAME) === CONFIGURATOR_PARAM_VALUE_ON;
    }, [history.location.search]);
    const { isMotorcyclesFilter } = getFilterOptionByProductType({
        productVariantsByColor,
        colorItemIndex,
    });
    const { isTransmission } = useTransmission();
    const onChangeColor = (index, colourId) => {
        const newVariant = prepareMotorcyclesFilterOptions({
            colorVariants,
            index,
            loweredVersion: productFilterOptions.loweredVersion,
            power: productFilterOptions.power,
            transmission: productFilterOptions.transmission,
            statusType: STATUS_COLOR_CHANGE,
        });
        if (newVariant?.sku && colorItemIndex !== index) {
            history.push({
                hash: newVariant.sku,
            });
            dispatch(setFilterOptions({
                colorItemIndex: index,
                sku: newVariant.sku,
                loweredVersion: newVariant.loweredVersion,
                power: newVariant.power,
                transmission: newVariant.transmission,
                colourId: newVariant.colourId || colourId,
            }));
        }
    };
    const pageHash = history.location.hash.replace('#', '').trim();
    useEffect(() => {
        if (isMotorcyclesFilter && !sku && isTransmission) {
            const colorIndex = productVariantsByColor && getColorIndex(productVariantsByColor, pageHash);
            if (isNumber(colorIndex)) {
                const currentVariant = prepareMotorcyclesFilterOptions({
                    colorVariants,
                    index: colorIndex >= 0 ? colorIndex : 0,
                    sku: colorIndex >= 0 ? pageHash : '',
                    statusType: pageHash && colorIndex >= 0 ? STATUS_RELOAD : STATUS_INIT,
                });
                if (currentVariant?.sku) {
                    dispatch(setFilterOptions(currentVariant));
                }
            }
            if (colorIndex === -1 && !isConfiguratorShowed) {
                history.replace({
                    hash: '',
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, productVariantsByColor, colorVariants, isTransmission, isConfiguratorShowed]);
    useEffect(() => {
        const onGoBackHandler = () => {
            const currentVariant = prepareMotorcyclesFilterOptions({
                colorVariants,
                index: colorItemIndex,
                sku: pageHash,
                statusType: STATUS_RELOAD,
            });
            dispatch(setFilterOptions(currentVariant));
        };
        window.addEventListener('popstate', onGoBackHandler);
        return () => {
            window.removeEventListener('popstate', onGoBackHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colorItemIndex, colorVariants, pageHash]);
    return {
        isMotorcyclesFilter,
        onChangeColor,
    };
}
